// src/App.js
import React from 'react';
import SearchBar from './Components/SearchBar';
import './App.css';




function App() {
  return (
    <div className="App">
      <SearchBar />
      {}
    </div>
  );
}

export default App;
